module.exports = __webpack_public_path__ + "img/0S6A0199.4ad7ba04.jpg";